import { gql } from "@apollo/client";
import { CampaignTagType, CompanyType } from "../__generated__/graphql";

export const postData = async (url = "", data = {}, headers = {}) => {
  const response = await fetch(url, {
    method: "POST",
    mode: "cors",
    credentials: "omit",
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    referrerPolicy: "origin",
    body: JSON.stringify(data),
  });
  return response.json();
};

export const UPDATE_PUBLICATION_QUERY = gql`
  mutation UpdatePublication($id: ObjectId!, $record: UpdatePublicationInput!) {
    PublicationUpdateById(_id: $id, record: $record) {
      _id
      name
      landingPage
      landingPageOverwritten
      budget
      kpi
      device
      startDate
      startDateOverwritten
      endDate
      endDateOverwritten
      trackingTag {
        tagType
        tagUrl
      }
      publicationType
      stage
      status
      finalUrl
      previewUrl
      rateCard {
        bidMultiplier
      }
      content {
        headline
        teaser
        coverImage
        contentObject
        contentImages
      }
      contentOverwritten
      actions {
        action
        disabled
        disabledReason
      }
    }
  }
`;


export interface User {
  _id: string,
  fullname: string,
  companyId: string,
  avatarUrl: string,
  company: {
    _id: string,
    name: string,
    type: CompanyType
  }
}

export const GET_ALL_ADVERTISERS_COUNTRY = gql`
  query AdvertiserMany {
    CompanyMany: AdvertiserMany(perPage: 1000) {
      items {
        name
        image
        country
        _id
        notes
        tag
      }
    }
  }
`;

// //Get queries

export enum KPI_TYPES {
  READ_TIME = 'Read Time',
  CTR = 'CTR'
}

export enum STAGE_TYPES {
  APPROVED = 'Approved',
  DRAFT = 'Draft',
  PRE_DRAFT = 'Pre-draft',
  PUBLISHED = 'Published',
  WAITING_FOR_ADVERTISER = 'Waiting_for_Advertiser',
  WAITING_FOR_PUBLISHER = 'Waiting_for_Publisher',

}

export enum PUBLICATION_TYPES {
  CONTIMO_HOSTED = 'CONTIMO_HOSTED',
  MANUAL = 'MANUAL'
}

export interface PublicationReportDay {
  date: string,
  reads: number,
  clicks: number
}

export interface PublicationReport {
  _id?: string,
  reads: number,
  clicks: number,
  daily: Array<PublicationReportDay>
}

export interface TrafficDriver {
  _id?: string,
  publicationId: string,
  header: string,
  teaser: string,
  imageId: string
}

export interface Publication {
  _id: string,
  name: string,
  kpi: KPI_TYPES,
  device: string,
  stage: STAGE_TYPES,
  finalUrl: string,
  publicationType: PUBLICATION_TYPES,
  slug: string,
  landingpage: string,
  trackingTag: {
    tagUrl: string,
    tagType: CampaignTagType
  }
  startDate: string,
  endDate: string,
  advertiser: {
    _id: string,
    name: string,
  },
  article: {
    content: {
      headline: string
    }
  },
  publisher: {
    _id: string
    name: string
    advertorialWebsite: string
  }
  createdAt: string,
  creatorId: string,
  creator: {
    fullname: string,
    company: {
      name: string
    }
  },
  report: PublicationReport,
  trafficDrivers: Array<TrafficDriver>,
  websiteId: string,
}

